import { createAction } from 'redux-actions'

const ns = 'verify-email/'

export type VerifyEmailPurpose = 'LOGIN' | 'SIGNUP' | 'PASSWORD_RESET'

export const setVerifyEmailContext = createAction<{ purpose: VerifyEmailPurpose; email?: string }>(`${ns}SET_CONTEXT`)
export const verifyEmailCode = createAction(`${ns}VERIFY_CODE`)
export const verifyEmailCodeSuccess = createAction(`${ns}VERIFY_CODE_SUCCESS`)
export const verifyEmailCodeFail = createAction<string>(`${ns}VERIFY_CODE_FAIL`)
export const resendVerificationCode = createAction(`${ns}RESEND_CODE`)
export const resendVerificationCodeSuccess = createAction(`${ns}RESEND_CODE_SUCCESS`)
export const resendVerificationCodeFail = createAction(`${ns}RESEND_CODE_FAIL`)
